// utils
import axios from 'axios';
import { url } from '../../../utils/urls';

// api parameters
const withCredentials = true;
const headers = {
    urlencoded: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    json: {
        'Content-Type': 'application/json'
    }
};

// api requests
export const postRevenueDetailRequest = (requestData) => {
    return axios.post(`${url.rms.rpm.revenue}/detail`, requestData, { headers: headers.urlencoded, withCredentials });
};

// api requests
export const postPublisherRevenueRequest = (requestData) => {
    return axios.post(`${url.rms.url}/v1/publisherrevenue`, requestData, { headers: headers.json, withCredentials });
};

export const postPrebidRevenueRequest = (requestData) => {
    return axios.post(`${url.rms.url}/v1/prebidrevenue`, requestData, { headers: headers.json, withCredentials });
};

export const getLatestProductRevenueDeduction = (date) => {
    return axios.get(`${url.rms.url}/v1/productrevenuededuction/${date}`, { withCredentials });
}

export const getLatestProductRevenueDeductionForAccount = (date, accountUUID) => {
    return axios.get(`${url.rms.url}/v1/account/${accountUUID}/productrevenuededuction/${date}`, { withCredentials });
}

export const postVideoPerformanceRequest = (requestData) => {
    return axios.post(`${url.rms.url}/v1/videoperformance`, requestData, { headers: headers.json, withCredentials });
}

export const postPageviewRequest = (requestData) => {
    return axios.post(`${url.rms.url}/v1/pageview`, requestData, { headers: headers.json, withCredentials });
}

export const getMcmAccountsRequest = () => {
    return axios.get(`${url.rms.url}/v1/mcmAccounts`, { withCredentials });
}

export const saveMcmAccountRequest = (requestData) => {
    return axios.post(`${url.rms.url}/v1/mcmAccounts`, requestData,{ withCredentials });
}